/**
 * plugins/index.ts
 *
 * Automatically included in `./src/main.ts`
 */

// Plugins
import initializeRouter from '@/router';
import vuetify from './vuetify';
import pinia from '../stores';
import i18n from '@/plugins/i18n';
import sentry from './sentry';
import './deep-libs';
import deviceDetectorJs from './device-detector-js';
import { VueQueryPlugin } from '@tanstack/vue-query';
import { createHead } from '@unhead/vue/client';

// Types
import type { App } from 'vue';
import fontawesome from '@/plugins/fontawesome.ts';
import { DeepMsgBoxPlugin } from '@deepcloud/deep-ui-lib';

export function registerPlugins(app: App) {
  const head = createHead();
  app.use(head);
  app.use(vuetify);
  app.use(pinia);
  app.use(fontawesome);
  app.use(i18n);
  app.use(sentry);
  app.use(VueQueryPlugin, {
    enableDevtoolsV6Plugin: true
  });
  app.use(deviceDetectorJs, { refreshOnResize: true });
  app.use(DeepMsgBoxPlugin, {
    msgBox: {
      i18n: i18n.global,
      closable: true,
      btnActions: {
        cancel: {
          name: 'cancel',
          titleI18nKey: 'buttons.cancel',
          color: 'primary',
          variant: 'outlined'
        },
        confirm: {
          name: 'confirm',
          titleI18nKey: 'buttons.confirm',
          color: 'primary',
          variant: 'flat'
        }
      },
      dialogProps: {
        persistent: true,
        width: 450
      }
    }
  });

  // Init router after all other plugins
  // https://github.com/dsb-norge/vue-keycloak-js/issues/94#issuecomment-1794403391
  // https://github.com/keycloak/keycloak/issues/14742#issuecomment-1663069438
  app.use(initializeRouter());
}
